// extracted by mini-css-extract-plugin
export default {"container":"Tags_container__j2fBQ","tag":"Tags_tag__CzkPy","tagButton":"Tags_tagButton__lhXuW","highlight":"Tags_highlight__nvE6A"};